import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";

const PERMISSIONS = {
    createRecurringTask: "recurring-task.create",
    readRecurringTask: "recurring-task.read",
    updateRecurringTask: "recurring-task.update",
    deleteRecurringTask: "recurring-task.delete",
    createDocument: "document.create",
    readDocument: "document.read",
    updateDocument: "document.update",
    deleteDocument: "document.delete",
    createSpace: "space.create",
    readSpace: "space.read",
    updateSpace: "space.update",
    deleteSpace: "space.delete",
    createCategory: "category.create",
    readCategory: "category.read",
    updateCategory: "category.update",
    deleteCategory: "category.delete",
    createUser: "user.create",
    readUser: "user.read",
    updateUser: "user.update",
    deleteUser: "user.delete",
    readMessengerFlow: "messenger-flow.read",
    updateMessengerFlow: "messenger-flow.update",
    readBilling: "billing.read",
    updateBilling: "billing.update",
    createRole: "role.create",
    readRole: "role.read",
    updateRole: "role.update",
    deleteRole: "role.delete",
};

export function usePermissions() {
    const permissionGroups = computed(() => {
        return usePage().props.permission_groups;
    });

    const userPermissions = computed(() => {
        return usePage().props.auth.permissions;
    });

    const hasPermission = (permission) => {
        return userPermissions.value.includes(permission);
    };

    return {
        PERMISSIONS,
        permissionGroups,
        userPermissions,
        hasPermission,
    };
}
